<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="30%"
    top="40vh"
    append-to-body
  >
    <div class="container">
      <div style="">
        <div
          class="text-center font-bold"
          style="color: #01b3e6; font-size: 40px"
        >
          <el-empty :description="content" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: true,
      key: "",
      filterList: [],
      content: "暂无数据",
    };
  },
  // props: {
  //   show: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  components: {},
  computed: {
    // visible: {
    //   get() {
    //     return this.show;
    //   },
    //   set(n) {
    //     this.$emit("update:show", n);
    //   },
    // },
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped lang="less">
.container {
  position: relative;
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-dialog__header {
//   }
//   .el-dialog__headerbtn {
//     top: 58px;
//     right: 30px;
//     z-index: 122;
//     font-size: 30px;
//   }
// }
</style>
